<div>
  <div class="row">
    <div *ngIf="allowsChannel" class="col-md-6">
      <app-select-search
        [items]="channels$ | async"
        [ctrl]="form.get('channels')"
        bindValue="id"
        bindLabel="label"
        [inline]="false"
        i18n-label
        label="From these Channels"
        i18n-placeholder
        placeholder="Apply to all channels"
        class="mat-block"
      >
        <ng-container class="error-container">
          <mat-error> <ng-container i18n>Channel is required</ng-container> </mat-error>
        </ng-container>
      </app-select-search>
    </div>
    <div *ngIf="allowsRental" class="col-md-6">
      <app-rental-select
        [ctrl]="form.get('rentals')"
        i18n-label
        label="From these Rentals"
        i18n-placeholder
        placeholder="Apply to all rentals"
        class="mat-block"
      >
      </app-rental-select>
    </div>
  </div>
</div>
